import { Content as t } from "./content/content.js";
import { Icon as r } from "./icon/icon.js";
import { Root as m } from "./root/root.js";
import { Title as n } from "./title/title.js";
const o = m;
o.Content = t;
o.Icon = r;
o.Title = n;
export {
  o as Alert
};
